/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setBrandPolicies} from '../api'

export const useMutationSetBrandPolicies = createReactQueryMutationHook('setBrandPolicies', setBrandPolicies)
